import { isEmailFunc, isRequiredFunc } from '../../Shared/Schema';
import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .required(isRequiredFunc('Email'))
    .email(isEmailFunc('Email')),
  password: Yup.string().required(isRequiredFunc('Password')),
});
